import angular = require("angular");
import TPL = require("templates");

import {SessionService} from "../../services/session";

export class HeaderDirective {

  scope = {};
  template;
  link;

  constructor(session: SessionService) {
    this.template = TPL.navigationDirectives.header;

    this.link = (scope, el, attrs)=> {
        scope.vm = {
          session: session,
          getLogoType: () => {
            //return scope.vm.session.isLogged()? "emblem" : "navbar";
            return "navbar";
          }
        };
    }
  }

  static factory() {
    var tmp = (a) => new HeaderDirective(a);
    tmp.$inject = ["session"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/header.ts
 **/